import { api } from './api';
import { ROLES } from './api/endpoints';

export const RoleService = {
  getAll: (params) => api.get(ROLES.ALL, { params }),
  getById: (id) => api.get(ROLES.BY_ID(id)),
  create: (data) => api.post(ROLES.CREATE, data),
  update: (id, data) => api.put(ROLES.UPDATE(id), data),
  delete: (id) => api.delete(ROLES.DELETE(id)),
  assignRole: (adminId, roleId) => api.post(ROLES.ASSIGN, { adminId, roleId }),
  getModules: () => api.get(ROLES.MODULES),
};

export default RoleService;
